export class ImageOptimizerReport {

  public id: string;
  public originalSize: string;
  public imageSize: string;
  public reduced: string;
  public reducedPercent: string;
  public url: string;
  public date: Date;
  public name: string;

}
